<template>
    <div class="listbox-outline">
        <h2 class="heading d-flex justify-content-between">
            <span>
                {{caption}}
            </span>
            <div v-if="link" class="link">
                <router-link :to="link" class="black">{{linkText}}</router-link>
            </div>
        </h2>
        <div class="listbox bg-blur" v-for="n in novels" :key="n.id">
            <component
                :is="isInternal(n) ? 'router-link':'a'"
                :href="!isInternal(n) ? bookLink(n): ''"
                :to="isInternal(n) ? bookLink(n) : ''"
                :target="isInternal(n) ? '_self' : subdomain(n)"
                class="d-flex justify-content-start text-reset"
                @click="showNovel($event, n)">
                <img v-lazy="n.cover_url.replace(/\.webp$/, '_thumb.webp') + '?' + n.cover_hash" class="d-block cover" v-if="n.cover_url" />
                <div v-else class="position-relative">
                    <img v-lazy="cover()" class="d-block cover" />
                    <div class="slider-text">
                        <div class="cover-text vertical">
                            <h3 class="novel-title mincho" v-html="$filters.ruby(n.title)"></h3>
                            <p v-if="n.subtitle" v-html="$filters.ruby(n.subtitle)"></p>
                        </div>
                    </div>
                </div>
                <div>
                    <h3 class="title mincho" v-html="$filters.ruby(n.title)"></h3>
                    <h4 class="subtitle d-none d-md-block" v-if="n.subtitle" v-html="$filters.ruby(n.subtitle)"></h4>
                    <h5 class="author">{{n.author.name}}</h5>
                    <p class="description">
                        {{ $filters.truncate(n.description, 180)}}
                    </p>
                </div>
            </component>
        </div>
    </div>
</template>

<style scoped lang="scss">
.listbox-outline {
    .listbox {
        margin-top: 1rem;
        width: 100%;
        height: 217px;
        background-color: white;
        border-radius: .7rem .7rem 0 0;
        box-shadow: 0 0 4px rgba(0, 0, 0, .1);
        overflow: hidden;
        a {
            &:hover {
                opacity: .8;
                text-decoration: none;
            }
        }
        .cover {
            object-fit: cover;
            height: 217px;
            min-width: 154px;
            width: 154px;
        }
        .title {
            font-size: 1.1rem;
            font-weight: bold;
            margin: 0;
            padding: 1rem 1rem 0;
        }
        .subtitle {
            font-size: .8rem;
            padding: .5rem 1rem 0;
        }
        .author {
            font-size: .8rem;
            padding: .5rem 1rem 0;
        }
        .description {
            font-size: .7rem;
            padding: .6rem 1rem;
        }
        .slider-text {
            position: absolute;
            top: 0;
            padding: 2.3rem;
            height: 250px;
            min-width: 177px;
            overflow: hidden;
            text-align: center;
            color: snow;
            .cover-text {
                display: inline-block;
                text-align: left;
                h3 {
                    font-size: .85rem;
                }
                p {
                    font-size: .6rem;
                }
            }
        }
    }
    .heading {
        font-size: 1rem;
        font-weight: bold;
        margin: 0;
        padding: 1rem 1rem .5rem;
    }
    .link {
        color: #222;
        font-size: .8rem;
        font-weight: lighter;
    }
}
@media screen and (max-width: 575px) {
    .listbox-outline {
        .listbox {
            width: calc(100vw - 10px);
        }
    }
}
</style>

<script>
export default {
    props: {
        novels: {
            required: true,
            default: [],
        },
        caption: {
            required: true,
            type: String,
        },
        link: {
            default: null,
        },
        linkText: {
            default: "もっと見る...",
        },
        hasDesc: {
            default: false,
        },
    },
    methods: {
        bookLink(n) {
            let url = "";
            const subdomain = this.subdomain(n);
            if (subdomain + this.$store.state.base_domain !== location.hostname) {
                url = `//${subdomain}${this.$store.state.base_domain}`;
            }
            if (n.is_long) {
                url += `/author/book/${n.id}`;
            } else {
                url += `/author/page/${n.id}/section/${n.sections[0].id}`;
            }
            return url;
        },
        subdomain(n) {
            let subdomain = "www";
            if (n.author && n.author.subdomain) {
                subdomain = n.author.subdomain.toLowerCase();
            }
            return subdomain;
        },
        isInternal(n) {
            if (this.bookLink(n).match(/^\/{2}/) || this.hasDesc) {
                return false;
            }
            return true;
        },
        showNovel(ev, n) {
            if (this.hasDesc) {
                ev.preventDefault();
                this.$emit("showNovel", n);
            }
        },
        cover() {
            const index = Math.floor(Math.random() * this.$store.getters.novelCovers.length);
            return this.$store.getters.novelCovers[index];
        },
    },
}
</script>